import { useUserStatus } from 'hooks/useUserStatus';
import { UpgradeButton } from 'pages/contacts/ContactItem/UpgradeButton';

import type { Contact } from '../../../../domain/contact';
import { hasPrivateData } from '../../../../domain/contact';
import { useContactsAvailabilityStatus } from '../../../../features/contacts/hooks/useContactsAvailabilityStatus';
import { useQuota } from '../../../../features/quota/hooks/useQuota';
import { CrmExportActionsContainer } from '../CrmExportActionsContainer';
import { GdprRestrictedButton } from '../GdprRestrictedButton';
import { RevealContainer } from '../RevealContainer';

export type ContactActionsContainerProps = {
  contact: Contact;
  setShouldAnimatePrivateDataMount: (shouldAnimate: boolean) => void;
};

export const ContactActionsContainer = (props: ContactActionsContainerProps) => {
  const { contact } = props;

  const { isGdprRestricted } = useContactsAvailabilityStatus();
  const { isTrialOrAfterTrial } = useUserStatus();

  const {
    quota: { isDepleted },
  } = useQuota();

  if (isGdprRestricted) {
    return <GdprRestrictedButton />;
  }

  if (isTrialOrAfterTrial && isDepleted) {
    return <UpgradeButton contact={contact} />;
  }

  if (hasPrivateData(contact)) {
    return <CrmExportActionsContainer contact={contact} />;
  }

  return <RevealContainer {...props} isQuotaDepleted={isDepleted} />;
};
